import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { zapMetadataAtomFamily_SUSPENDS } from "../zaps/zapAtomFamily_SUSPENDS";
import { AssetType } from "../types";
import { fetchTableFieldsAtomFamily_SUSPENDS } from "./fetchTableFieldsAtomFamily_SUSPENDS";
import { fetchChatbotAtomFamily_SUSPENDS } from "./fetchChatbotAtomFamily_SUSPENDS";
import { fetchInterfacePageAtomFamily_SUSPENDS } from "./fetchInterfacePageAtomFamily_SUSPENDS";
import { fetchInterfaceProjectAtomFamily_SUSPENDS } from "./fetchInterfaceProjectAtomFamily_SUSPENDS";

type AssetParams = {
  assetType: AssetType;
  assetId: string | null;
  interfaceProjectId: string | undefined;
};

export const assetAtomFamily_SUSPENDS = atomFamily(
  ({ assetType, assetId, interfaceProjectId }: AssetParams) => {
    const baseAtom = atom(async (get) => {
      if (assetType === "zap" && assetId) {
        return await get(zapMetadataAtomFamily_SUSPENDS(assetId));
      }

      if (assetType === "table" && assetId) {
        return await get(fetchTableFieldsAtomFamily_SUSPENDS(assetId));
      }

      if (assetType === "chatbot" && assetId) {
        return await get(fetchChatbotAtomFamily_SUSPENDS(assetId));
      }

      // assetId for interfaces will be the pageId
      if (assetType === "interface") {
        if (assetId) {
          return await get(fetchInterfacePageAtomFamily_SUSPENDS(assetId));
        }

        if (interfaceProjectId) {
          return await get(
            fetchInterfaceProjectAtomFamily_SUSPENDS(interfaceProjectId),
          );
        }
      }

      return null;
    });

    baseAtom.debugLabel = `assetAtomFamily_SUSPENDS(${JSON.stringify({ assetType, assetId, interfaceProjectId })})`;

    return baseAtom;
  },
  (a, b) =>
    a.assetType === b.assetType &&
    a.assetId === b.assetId &&
    a.interfaceProjectId === b.interfaceProjectId,
);
